<template>
  <div style="position: relative;">
    <container>
      <middle-title style="margin-bottom: 40px" title="公司动态" :description="description" />
      <a-row type="flex" :gutter="[32, 32]">
        <a-col v-for="(blog, index) in blogs" :xxl="8" :xl="8" :lg="12" :md="24" :sm="24" :key="index">
          <div style="position: relative">
            <div class="post-date bg-primary">
              <div class="date">{{ blog.day }}</div>
              <div class="month">{{ blog.month }}</div>
              <div class="year">{{ blog.year }}</div>
            </div>
            <div class="img-effect">
              <img :src="blog.img" style="object-fit: cover;" />
            </div>
            <div class="blog-info">
              <h5 class="title"><a>{{ blog.title }}</a></h5>
              <p style="margin-top: 10px" class="description">
                {{ blog.description }}
              </p>
              <a style="font-weight: bold" :href="blog.url" target="blank">
                阅读全文
                <DoubleRightOutlined />
              </a>
              <div class="post-tags clearfix">
                <div class="tag" v-for="(item, i) in blog.tag" :key="i">{{ item }}</div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </container>
  </div>

</template>

<script>
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import MiddleTitle from '@/components/common/MiddleTitle'
export default {
  name: 'BlogGrid',
  components: { MiddleTitle, DoubleRightOutlined },
  data() {
    return {
      img: require('@/assets/image/article/anniversary.jpg'),
      description: '辰宇矢志成为行业领先的环球财务规划服务机构，帮助客户实现不同阶段的财智人生，引领环球财务规划行业快速发展！',
      blogs: [
        {
          year: '2025',
          month: 'Oct',
          day: '24',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20251024.png',
          title: '新址启幕 笃行致远 | 辰宇太原分公司乔迁盛典举行',
          description: '2025年10月24日，辰宇太原分公司完成了又一次重要腾飞——正式乔迁至 山西太原万柏林区长兴北街9号华润大厦T5栋28层2818室 ，踞城市之巅，开启全新篇章。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247580041&idx=1&sn=0de45733a68b72bf7c1254c09593c55f&chksm=fdb72ef9cac0a7efb2dc0f3fb7764f5948a9fec632a2ed16a15dfbaa25b7a044058b82f5ee10&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '公司动态', '太原公司乔迁']
        },
        {
          year: '2025',
          month: 'Oct',
          day: '30',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20251030.png',
          title: '星城启幕 湘聚未来 | 辰宇长沙分公司开业盛典圆满落幕',
          description: '2025年10月30日，辰宇集团发展的版图上，再添一颗璀璨的星辰——辰宇长沙分公司，于这座媒体艺术之都与创新活力之都的心脏地带， 长沙国金中心T1大楼37层3706单元 ，正式扬帆启航。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247580353&idx=1&sn=362bb2b94ec2347e3076346266496900&chksm=fdb72db1cac0a4a74ca822d7c3304d03a841fcca1e989630ae0c5fa648eff3d9ea0d16edcf93&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '公司动态', '长沙公司开业']
        },
        {
          year: '2025',
          month: 'Jul',
          day: '19',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20250719.jpg',
          title: '新经济·新机遇：首届青创精英创新创业者论坛大会——暨致敬郭奎章青创团十周年大会',
          description: '2025年7月19日，辰宇集团与青创精英商学联合主办、青创团&时尚湾流共同联办了首届“新经济 新机遇”创新创业者论坛大会暨郭奎章青创团十周年致敬盛典。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247578168&idx=1&sn=4a8ac41b3c696b09901533592e291eb3&chksm=fdb72548cac0ac5eccf6ecdec4203ffef90a9f7b3b93c3be677cfa88ddb3357eca4827ff564e&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '公司动态', '创新创业者论坛大会']
        },
        {
          year: '2025',
          month: 'Jul',
          day: '7',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20250707.jpg',
          title: '历9弥新，惟精惟一 | 辰宇2025年第二季度会议暨九周年庆典圆满落幕',
          description: '2025年7月7日，辰宇第二季度会议暨九周年庆典于深圳隆重举行！',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247576863&idx=1&sn=d86e8b96d1a5ee418665730d33ce10f0&chksm=fdb73a6fcac0b379cf911d7e517228d4f24363a22c044924e9205fd3c22b6211698fbd25be30&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '公司动态', '9周年庆']
        },
        {
          year: '2025',
          month: 'May',
          day: '21',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20250521.jpg',
          title: '辰宇集团与SZBOX达成战略合作 共启文创产业新篇章',
          description: '2025年5月21日，辰宇集团与SZBOX盒子文创在深圳隆重举行战略合作签约仪式，双方正式宣布达成深度合作关系。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247573486&idx=1&sn=17bf83415f02c7ce510d0e9a9b83639a&chksm=fdb7489ecac0c18860a1b6e5bb1c7d8112ccedc896dc62d67ca4588946fb5e866bec69e28d29&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '产业联盟时代', 'SZBOX', '文创产业项目']
        },
        {
          year: '2025',
          month: 'Apr',
          day: '29',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20250429.jpg',
          title: '辰宇集团携手多方共筑深圳南澳MOMOO茉茉海度假区，共绘文旅新蓝图',
          description: '2025年4月29日，以“时尚湾流 携手共赢”为主题的深圳南澳MOMOO茉茉海度假区投资签约仪式在辰宇集团总部圆满举行。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247572981&idx=1&sn=b3b23071dec16ea868ab6cbe94313af3&chksm=fdb74a85cac0c3930c70773af5a6038eaf5ab24cc7441cdcfc2f4a9d71acf52f730cbe7a092e&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '产业联盟时代', 'MOMOO茉茉海', '文旅项目']
        },
        {
          year: '2025',
          month: 'Apr',
          day: '13',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20250413.jpg',
          title: '澳洲印记 | 「宇」你一起共绘星辰海图',
          description: '2025年度SUNIVERS CONVENTION圆满落幕！',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247572728&idx=1&sn=bc96412b6f1fc3875c1d2f81abdf4e2f&chksm=fdb74b88cac0c29e62474e37d9976266bb5489e02b45039f7c6147bfb74883a1511c2baa6d7f&scene=178&cur_album_id=2915260482901753857&search_click_id=#rd',
          tag: ['辰宇集团', '公司动态', 'SUNIVERS CONVENTION']
        },
        {
          year: '2025',
          month: 'Mar',
          day: '25',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/image4.jpg',
          title: '致初心 绽新辉 | 辰宇集团总部乔迁盛典圆满举行',
          description: '2025年3月25日， 辰宇集团总部正式乔迁至深圳市福田区华强科创广场1栋38楼 。从最初百平的初创空间，到如今逾三千平方米的现代化智慧总部，这场跨越式的蜕变，不仅见证了辰宇集团从“小而精”到“大而强”的跨越，更彰显了立足大湾区、辐射全中国的战略雄心。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247570965&idx=1&sn=d47fa95a2070fd5856ed84f83cc8c09a&chksm=fdb74165cac0c87345e71d39f03e5c3b8987227d10dd00f77b093ad59b265030e524264b200b&scene=178&cur_album_id=2915260482901753857#rd',
          tag: ['辰宇集团', '深圳总部', '乔迁']
        },
        {
          year: '2024',
          month: 'Dec',
          day: '6',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/20241206.jpg',
          title: '辰宇出海 | 泰国EEC工业区酒店公寓项目动工仪式圆满举办',
          description: '2024年12月6日，辰宇集团迎来了一个新的里程碑。在泰国EEC工业区，集团首个参与开发的酒店公寓项目正式动工，这标志着辰宇集团的业务版图成功进一步拓展至国际市场。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247566725&idx=2&sn=45ea7d3d9ea3b0e04eeef9caa5ba7380&chksm=fdb752f5cac0dbe30d6bb15adcf0a7cd43d18201683407fc36abf9b1f6a698112d72d8b2e229&scene=178&cur_album_id=2915260482901753857#rd',
          tag: ['辰宇集团', '泰国EEC工业区酒店公寓项目动工仪式']
        },
        {
          year: '2024',
          month: 'Sep',
          day: '28',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/image1.jpg',
          title: '在黑暗中，让音乐唤醒灵魂 | “大开眼界”黑暗公益音乐话剧圆满结束！',
          description: '2024年9月28日，辰宇集团携手黑暗中对话深圳馆举办了一场一场黑暗公益音乐话剧《大开眼界》，剧情与音符的交织，为参与者带来了一场触动心灵与感官的双重盛宴。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247562551&idx=2&sn=24908cd6c680e79144146166f2d4ce3d&chksm=fdb76247cac0eb519bb2fd8fe3c37100f7d2674ad79f05609e151f2e37b25a33287b0e887d95&token=1803320377&lang=zh_CN#rd',
          tag: ['辰宇公益', '黑暗公益音乐话剧']
        },
        {
          year: '2024',
          month: 'Jun',
          day: '1',
          img: 'https://sunivers-erp.oss-cn-shenzhen.aliyuncs.com/prod/offcial-site/offcial-site/article/image3.jpg',
          title: '辰宇公益四年，照亮孩子们的追梦之路！',
          description: '正值加油未来项目迎来十周年庆典，辰宇集团深感荣幸被邀请参加这一盛大的活动，并荣获了“善行伙伴”的称号。',
          url: 'https://mp.weixin.qq.com/s?__biz=MzU4MjY2NDczNQ==&mid=2247555164&idx=1&sn=1232f1c3e1c90c17561a1879f912f81c&chksm=fdb68f2ccac1063ab4d06f69af05f1456b92ae04d722528d32fb222713651c1e83c26cdb41be&scene=178&cur_album_id=2915260482901753857#rd',
          tag: ['辰宇公益', '善行伙伴', '月捐计划']
        },
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.post-date {
  z-index: 10;
  color: #fff;
  position: absolute;
  left: 20px;
  top: 0;
  padding: 0 10px;
  text-align: center;
  text-transform: uppercase;

  & .date {
    font-weight: 600;
    font-size: 15px;
    padding: 10px 5px 5px;
    position: relative;
  }

  & .month {
    position: relative;
    font-size: 12px;

    &:after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 50%;
      height: 1px;
      background-color: #fff;
      margin: 0 -10px;
      width: 20px;
    }
  }

  & .year {
    margin-top: 8px;
  }

}

.img-effect {
  position: relative;
  overflow: hidden;
  display: block;
  vertical-align: middle;

  img {
    width: 100%;
    height: 170px;
  }
}

.blog-info {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ebebeb;

  & .title {
    margin-bottom: 10px;
  }

  & .post-tags {
    margin-top: 10px;
    border-top: 1px solid #e9e9e9;
    padding-top: 10px;

    & .tag {
      font-size: 13px;
      border: 1px solid #ebebeb;
      padding: 2px 8px 1px;
      color: #777;
      margin: 3px;
      display: inline-block;
    }
  }
}
</style>
